var map = {
	"./AiranJostina.png": 6508,
	"./Ennatha.png": 2625,
	"./Erdentuya.png": 8804,
	"./LiatrisDelAlbens.png": 933,
	"./PennyPita.png": 1520,
	"./RuVirtanen.png": 9854,
	"./SulSujeong.png": 6987,
	"./bg-character_name.png": 3560,
	"./frame-w.png": 9070,
	"./frame.png": 3355,
	"./unknown.png": 1358
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1090;